import React from 'react';

import Container from 'react-bootstrap/Container';

function SponsorsSection() {
  return (
    <div className="site-section" style={{ paddingBottom: 0 }}>
      <Container fluid="md">
        <h2>
          Corporate Sponsors
        </h2>
        <br />
        <p className="lead">
          We work with organizations to develop solutions that are fully customizable, scalable, and maintainable.
          Whether it&apos;s implementing our matching software or accessing our volunteer base, we want to work with you.
        </p>
      </Container>
    </div>
  );
}

export default SponsorsSection;
